module.exports = __webpack_public_path__ + "static/img/16.d3a7c419.jpg";